import React from 'react'

export const LoadingDots = () => {
  return (
    <div className='loading'>
      <i className='loader ball-beat'>
        <span />
        <span />
        <span />
      </i>
    </div>
  )
}
